/**
 * The url to 404 page is the same as on WEB4U website.
 * "/en-uk/system/404"
 */
export const redirectToErrorPage = () => {
  window.location.pathname =
    '/' + window.location.pathname.split('/')[1] + '/system/404';
};



// WEBPACK FOOTER //
// ./src/utils/redirectToErrorPage/redirectToErrorPage.js